// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var KeyCommand$SmartcutsMacros = require("./commands/KeyCommand.bs.js");
var URLCommand$SmartcutsMacros = require("./commands/URLCommand.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var TypeCommand$SmartcutsMacros = require("./commands/TypeCommand.bs.js");
var ClickCommand$SmartcutsMacros = require("./commands/ClickCommand.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var RadioCommand$SmartcutsMacros = require("./commands/RadioCommand.bs.js");
var NewTabCommand$SmartcutsMacros = require("./commands/NewTabCommand.bs.js");
var ScrollCommand$SmartcutsMacros = require("./commands/ScrollCommand.bs.js");
var SelectCommand$SmartcutsMacros = require("./commands/SelectCommand.bs.js");
var SwitchCommand$SmartcutsMacros = require("./commands/SwitchCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var CommandContext$SmartcutsMacros = require("./CommandContext.bs.js");
var CheckboxCommand$SmartcutsMacros = require("./commands/CheckboxCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var FocusTabCommand$SmartcutsMacros = require("./commands/FocusTabCommand.bs.js");
var KeyComboCommand$SmartcutsMacros = require("./commands/KeyComboCommand.bs.js");
var PasswordCommand$SmartcutsMacros = require("./commands/PasswordCommand.bs.js");
var NewWindowCommand$SmartcutsMacros = require("./commands/NewWindowCommand.bs.js");
var ClickInputCommand$SmartcutsMacros = require("./commands/ClickInputCommand.bs.js");
var OpenedLinkCommand$SmartcutsMacros = require("./commands/OpenedLinkCommand.bs.js");
var SubmitFormCommand$SmartcutsMacros = require("./commands/SubmitFormCommand.bs.js");
var ContextMenuCommand$SmartcutsMacros = require("./commands/ContextMenuCommand.bs.js");
var ClickToOAuthCommand$SmartcutsMacros = require("./commands/ClickToOAuthCommand.bs.js");
var CopyImageSrcCommand$SmartcutsMacros = require("./commands/CopyImageSrcCommand.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var PasteInInputCommand$SmartcutsMacros = require("./commands/PasteInInputCommand.bs.js");
var NewTabWithUrlCommand$SmartcutsMacros = require("./commands/NewTabWithUrlCommand.bs.js");
var ClientRedirectCommand$SmartcutsMacros = require("./commands/ClientRedirectCommand.bs.js");
var ServerRedirectCommand$SmartcutsMacros = require("./commands/ServerRedirectCommand.bs.js");
var CopyLinkAddressCommand$SmartcutsMacros = require("./commands/CopyLinkAddressCommand.bs.js");
var MoveInputCursorCommand$SmartcutsMacros = require("./commands/MoveInputCursorCommand.bs.js");
var NewWindowWithUrlCommand$SmartcutsMacros = require("./commands/NewWindowWithUrlCommand.bs.js");
var SelectionRelatedCommands$SmartcutsMacros = require("./commands/shared/SelectionRelatedCommands.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var SubmitFormRedirectCommand$SmartcutsMacros = require("./commands/SubmitFormRedirectCommand.bs.js");
var DataExtraction__DataRecord$SmartcutsMacros = require("../../bs-data-extraction/src/DataExtraction__DataRecord.bs.js");
var ClickContentEditableCommand$SmartcutsMacros = require("./commands/ClickContentEditableCommand.bs.js");
var ScreenshotToClipboardCommand$SmartcutsMacros = require("./commands/ScreenshotToClipboardCommand.bs.js");
var DataExtraction__ExportToTable$SmartcutsMacros = require("../../bs-data-extraction/src/DataExtraction__ExportToTable.bs.js");
var PasteInContentEditableCommand$SmartcutsMacros = require("./commands/PasteInContentEditableCommand.bs.js");
var GenericCommandWithContextGlobal$SmartcutsMacros = require("./GenericCommandWithContextGlobal.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");
var MoveContentEditableCursorCommand$SmartcutsMacros = require("./commands/MoveContentEditableCursorCommand.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");
var PasteImageInContentEditableCommand$SmartcutsMacros = require("./commands/PasteImageInContentEditableCommand.bs.js");
var WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros = require("./commands/WithElementGroupsCommand__Playback__FinalEffect.bs.js");

function t_encode(encoder_commandType, v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_commandType, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}

function t_decode(decoder_commandType, v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_commandType, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}

function stringify(param, stringifyCommand) {
  return "{ id: " + (String(param.id) + (", command: " + (Curry._1(stringifyCommand, param.command) + ", contextGlobal }")));
}

var CommandWithContextGlobal = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function t_encode$1(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* ReloadCommand */0 :
          return ["ReloadCommand"];
      case /* ForwardCommand */1 :
          return ["ForwardCommand"];
      case /* BackCommand */2 :
          return ["BackCommand"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* NewWindowCommand */0 :
          return [
                  "NewWindowCommand",
                  NewWindowCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewWindowWithUrlCommand */1 :
          return [
                  "NewWindowWithUrlCommand",
                  NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewTabCommand */2 :
          return [
                  "NewTabCommand",
                  NewTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewTabWithUrlCommand */3 :
          return [
                  "NewTabWithUrlCommand",
                  NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* CloseTabCommand */4 :
          return [
                  "CloseTabCommand",
                  InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
                ];
      case /* FocusTabCommand */5 :
          return [
                  "FocusTabCommand",
                  FocusTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* URLCommand */6 :
          return [
                  "URLCommand",
                  URLCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* OpenedLinkCommand */7 :
          return [
                  "OpenedLinkCommand",
                  OpenedLinkCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SubmitFormCommand */8 :
          return [
                  "SubmitFormCommand",
                  SubmitFormCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SubmitFormRedirectCommand */9 :
          return [
                  "SubmitFormRedirectCommand",
                  SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ClientRedirectCommand */10 :
          return [
                  "ClientRedirectCommand",
                  ClientRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ServerRedirectCommand */11 :
          return [
                  "ServerRedirectCommand",
                  ServerRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ClickCommand */12 :
          return [
                  "ClickCommand",
                  Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* ClickInputCommand */13 :
          return [
                  "ClickInputCommand",
                  Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* ClickContentEditableCommand */14 :
          return [
                  "ClickContentEditableCommand",
                  Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* TypeCommand */15 :
          return [
                  "TypeCommand",
                  Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* CheckboxCommand */16 :
          return [
                  "CheckboxCommand",
                  Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* SelectCommand */17 :
          return [
                  "SelectCommand",
                  Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* RadioCommand */18 :
          return [
                  "RadioCommand",
                  Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* KeyCommand */19 :
          return [
                  "KeyCommand",
                  KeyCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* KeyComboCommand */20 :
          return [
                  "KeyComboCommand",
                  KeyComboCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SelectionCommand */21 :
          return [
                  "SelectionCommand",
                  Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* MoveInputCursorCommand */22 :
          return [
                  "MoveInputCursorCommand",
                  Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* MoveContentEditableCursorCommand */23 :
          return [
                  "MoveContentEditableCursorCommand",
                  Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* CopyCommand */24 :
          return [
                  "CopyCommand",
                  Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* CopyLinkAddressCommand */25 :
          return [
                  "CopyLinkAddressCommand",
                  Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* CutCommand */26 :
          return [
                  "CutCommand",
                  Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* PasteInInputCommand */27 :
          return [
                  "PasteInInputCommand",
                  Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* PasteInContentEditableCommand */28 :
          return [
                  "PasteInContentEditableCommand",
                  Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* DragCommand */29 :
          return [
                  "DragCommand",
                  Selector$SmartcutsMacros.selector_encode(v._0)
                ];
      case /* DropCommand */30 :
          return [
                  "DropCommand",
                  Selector$SmartcutsMacros.selector_encode(v._0)
                ];
      case /* ScrollCommand */31 :
          return [
                  "ScrollCommand",
                  ScrollCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* DownloadCommand */32 :
          return [
                  "DownloadCommand",
                  Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* GoogleSheetsCommand */33 :
          return [
                  "GoogleSheetsCommand",
                  Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* ContextMenuCommand */34 :
          return [
                  "ContextMenuCommand",
                  Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* LoopCommand */35 :
          return [
                  "LoopCommand",
                  LoopCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SwitchCommand */36 :
          return [
                  "SwitchCommand",
                  Curry._1(SwitchCommandPlaybackRuntime.t_encode, v._0)
                ];
      case /* ScreenshotToClipboardCommand */37 :
          return [
                  "ScreenshotToClipboardCommand",
                  Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* PasteImageInContentEditableCommand */38 :
          return [
                  "PasteImageInContentEditableCommand",
                  Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* PasswordCommand */39 :
          return [
                  "PasswordCommand",
                  Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* ClickToOAuthCommand */40 :
          return [
                  "ClickToOAuthCommand",
                  Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* UploadCommand */41 :
          return [
                  "UploadCommand",
                  Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* CopyImageSrcCommand */42 :
          return [
                  "CopyImageSrcCommand",
                  Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
                ];
      case /* WithElementGroupsCommand */43 :
          return [
                  "WithElementGroupsCommand",
                  Curry._1(WithElementGroupsCommandPlaybackRuntime.t_encode, v._0)
                ];
      
    }
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BackCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BackCommand */2
                  };
          }
      case "CheckboxCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CheckboxCommand */16,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ClickCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickCommand */12,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ClickContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickContentEditableCommand */14,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ClickInputCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickInputCommand */13,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ClickToOAuthCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickToOAuthCommand */40,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "ClientRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = ClientRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClientRedirectCommand */10,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "CloseTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CloseTabCommand */4,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "ContextMenuCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContextMenuCommand */34,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "CopyCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyCommand */24,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "CopyImageSrcCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyImageSrcCommand */42,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "CopyLinkAddressCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyLinkAddressCommand */25,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "CutCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CutCommand */26,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "DownloadCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadCommand */32,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "DragCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DragCommand */29,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "DropCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DropCommand */30,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "FocusTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = FocusTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FocusTabCommand */5,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "ForwardCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ForwardCommand */1
                  };
          }
      case "GoogleSheetsCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoogleSheetsCommand */33,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "KeyComboCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = KeyComboCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyComboCommand */20,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "KeyCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = KeyCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyCommand */19,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "LoopCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = LoopCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LoopCommand */35,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "MoveContentEditableCursorCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MoveContentEditableCursorCommand */23,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "MoveInputCursorCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MoveInputCursorCommand */22,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "NewTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = NewTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewTabCommand */2,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "NewTabWithUrlCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewTabWithUrlCommand */3,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "NewWindowCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = NewWindowCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewWindowCommand */0,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "NewWindowWithUrlCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewWindowWithUrlCommand */1,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "OpenedLinkCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$26 = OpenedLinkCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$26.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OpenedLinkCommand */7,
                      _0: v0$26._0
                    }
                  };
          }
          var e$26 = v0$26._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "PasswordCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$27 = Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$27.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCommand */39,
                      _0: v0$27._0
                    }
                  };
          }
          var e$27 = v0$27._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
      case "PasteImageInContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$28 = Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$28.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteImageInContentEditableCommand */38,
                      _0: v0$28._0
                    }
                  };
          }
          var e$28 = v0$28._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "PasteInContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$29 = Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$29.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteInContentEditableCommand */28,
                      _0: v0$29._0
                    }
                  };
          }
          var e$29 = v0$29._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                  }
                };
      case "PasteInInputCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$30 = Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$30.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteInInputCommand */27,
                      _0: v0$30._0
                    }
                  };
          }
          var e$30 = v0$30._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "RadioCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$31 = Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$31.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RadioCommand */18,
                      _0: v0$31._0
                    }
                  };
          }
          var e$31 = v0$31._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$31.path,
                    message: e$31.message,
                    value: e$31.value
                  }
                };
      case "ReloadCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ReloadCommand */0
                  };
          }
      case "ScreenshotToClipboardCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$32 = Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$32.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScreenshotToClipboardCommand */37,
                      _0: v0$32._0
                    }
                  };
          }
          var e$32 = v0$32._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                  }
                };
      case "ScrollCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$33 = ScrollCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$33.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScrollCommand */31,
                      _0: v0$33._0
                    }
                  };
          }
          var e$33 = v0$33._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$33.path,
                    message: e$33.message,
                    value: e$33.value
                  }
                };
      case "SelectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$34 = Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$34.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectCommand */17,
                      _0: v0$34._0
                    }
                  };
          }
          var e$34 = v0$34._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "SelectionCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$35 = Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$35.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectionCommand */21,
                      _0: v0$35._0
                    }
                  };
          }
          var e$35 = v0$35._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$35.path,
                    message: e$35.message,
                    value: e$35.value
                  }
                };
      case "ServerRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$36 = ServerRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$36.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ServerRedirectCommand */11,
                      _0: v0$36._0
                    }
                  };
          }
          var e$36 = v0$36._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "SubmitFormCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$37 = SubmitFormCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$37.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubmitFormCommand */8,
                      _0: v0$37._0
                    }
                  };
          }
          var e$37 = v0$37._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$37.path,
                    message: e$37.message,
                    value: e$37.value
                  }
                };
      case "SubmitFormRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$38 = SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$38.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubmitFormRedirectCommand */9,
                      _0: v0$38._0
                    }
                  };
          }
          var e$38 = v0$38._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      case "SwitchCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$39 = Curry._1(SwitchCommandPlaybackRuntime.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$39.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SwitchCommand */36,
                      _0: v0$39._0
                    }
                  };
          }
          var e$39 = v0$39._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$39.path,
                    message: e$39.message,
                    value: e$39.value
                  }
                };
      case "TypeCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$40 = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$40.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TypeCommand */15,
                      _0: v0$40._0
                    }
                  };
          }
          var e$40 = v0$40._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$40.path,
                    message: e$40.message,
                    value: e$40.value
                  }
                };
      case "URLCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$41 = URLCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$41.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* URLCommand */6,
                      _0: v0$41._0
                    }
                  };
          }
          var e$41 = v0$41._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$41.path,
                    message: e$41.message,
                    value: e$41.value
                  }
                };
      case "UploadCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$42 = Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$42.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UploadCommand */41,
                      _0: v0$42._0
                    }
                  };
          }
          var e$42 = v0$42._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$42.path,
                    message: e$42.message,
                    value: e$42.value
                  }
                };
      case "WithElementGroupsCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$43 = Curry._1(WithElementGroupsCommandPlaybackRuntime.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$43.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WithElementGroupsCommand */43,
                      _0: v0$43._0
                    }
                  };
          }
          var e$43 = v0$43._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(command) {
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
          return "ReloadCommand";
      case /* ForwardCommand */1 :
          return "ForwardCommand";
      case /* BackCommand */2 :
          return "BackCommand";
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowCommand */0 :
          return "NewWindowCommand(" + (NewWindowCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewWindowWithUrlCommand */1 :
          return "NewWindowWithUrlCommand(" + (NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewTabCommand */2 :
          return "NewTabCommand(" + (NewTabCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewTabWithUrlCommand */3 :
          return "NewTabWithUrlCommand(" + (NewTabWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* CloseTabCommand */4 :
          return "CloseTabCommand(tabRef=" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(command._0) + ")");
      case /* FocusTabCommand */5 :
          var func = FocusTabCommand$SmartcutsMacros.CommandValue.stringify;
          return "FocusTabCommand(tabRef=" + (Curry._2(func, InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, command._0) + ")");
      case /* URLCommand */6 :
          return "URLCommand(" + (URLCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* OpenedLinkCommand */7 :
          return "OpenedLinkCommand(" + (OpenedLinkCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SubmitFormCommand */8 :
          return "SubmitFormCommand(" + (SubmitFormCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SubmitFormRedirectCommand */9 :
          return "SubmitFormRedirectCommand(" + (SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ClientRedirectCommand */10 :
          return "ClientRedirectCommand(" + (ClientRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ServerRedirectCommand */11 :
          return "ServerRedirectCommand(" + (ServerRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ClickCommand */12 :
          return "ClickCommand(" + (Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* ClickInputCommand */13 :
          return "ClickInputCommand(" + (Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* ClickContentEditableCommand */14 :
          return "ClickContentEditableCommand(" + (Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* TypeCommand */15 :
          return "TypeCommand(" + (Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* CheckboxCommand */16 :
          return "CheckboxCommand(" + (Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* SelectCommand */17 :
          return "SelectCommand(" + (Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* RadioCommand */18 :
          return "RadioCommand(" + (Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* KeyCommand */19 :
          return "KeyCommand(" + (KeyCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* KeyComboCommand */20 :
          return "KeyComboCommand(" + (KeyComboCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SelectionCommand */21 :
          return "SelectionCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* MoveInputCursorCommand */22 :
          return "MoveInputCursorCommand(" + (Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* MoveContentEditableCursorCommand */23 :
          return "MoveContentEditableCursorCommand(" + (Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* CopyCommand */24 :
          return "CopyCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* CopyLinkAddressCommand */25 :
          return "CopyLinkAddressCommand(" + (Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* CutCommand */26 :
          return "CutCommand(" + (Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* PasteInInputCommand */27 :
          return "PasteInInputCommand(" + (Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* PasteInContentEditableCommand */28 :
          return "PasteInContentEditableCommand(" + (Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* DragCommand */29 :
          return "DragCommand(domElement=" + (Selector$SmartcutsMacros.stringify(undefined, false, command._0) + ")");
      case /* DropCommand */30 :
          return "DropCommand(domElement=" + (Selector$SmartcutsMacros.stringify(undefined, false, command._0) + ")");
      case /* ScrollCommand */31 :
          return "ScrollCommand(delta(x, y))";
      case /* DownloadCommand */32 :
          return "DownloadCommand(" + (Curry._1(DownloadCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* GoogleSheetsCommand */33 :
          return "GoogleSheetsCommand(" + (Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* ContextMenuCommand */34 :
          return "ContextMenuCommand(" + (Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* LoopCommand */35 :
          return "LoopCommand(" + LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0);
      case /* SwitchCommand */36 :
          return "SwitchCommand(" + (Curry._1(SwitchCommandPlaybackRuntime.stringify, command._0) + ")");
      case /* ScreenshotToClipboardCommand */37 :
          return "ScreenshotToClipboardCommand(" + (Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* PasteImageInContentEditableCommand */38 :
          return "PasteImageInContentEditableCommand(" + (Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* PasswordCommand */39 :
          return "PasswordCommand(" + (Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* ClickToOAuthCommand */40 :
          return "ClickToOAuthCommand(" + (Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* UploadCommand */41 :
          return "UploadCommand(" + (Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* CopyImageSrcCommand */42 :
          return "CopyImageSrcCommand(" + (Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.stringify, command._0) + ")");
      case /* WithElementGroupsCommand */43 :
          return "WithElementGroupsCommand(" + (Curry._1(WithElementGroupsCommandPlaybackRuntime.stringify, command._0) + ")");
      
    }
  }
}

var CommandType = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function caseThatEvaluatedToTrue_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Default" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Default */0
                  };
          }
      case "Predicate" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Predicate */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function caseThatEvaluatedToTrue_encode(v) {
  if (v) {
    return [
            "Predicate",
            Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.t_encode, v._0)
          ];
  } else {
    return ["Default"];
  }
}

function resolvedToCommands_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var caseThatEvaluatedToTrue = caseThatEvaluatedToTrue_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "caseThatEvaluatedToTrue"), null));
  if (caseThatEvaluatedToTrue.TAG === /* Ok */0) {
    var commandsWithContextGlobal = Decco.arrayFromJson((function (param) {
            return t_decode(t_decode$1, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandsWithContextGlobal"), null));
    if (commandsWithContextGlobal.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                caseThatEvaluatedToTrue: caseThatEvaluatedToTrue._0,
                commandsWithContextGlobal: commandsWithContextGlobal._0
              }
            };
    }
    var e = commandsWithContextGlobal._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".commandsWithContextGlobal" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = caseThatEvaluatedToTrue._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".caseThatEvaluatedToTrue" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function resolvedToCommands_encode(v) {
  return Js_dict.fromArray([
              [
                "caseThatEvaluatedToTrue",
                caseThatEvaluatedToTrue_encode(v.caseThatEvaluatedToTrue)
              ],
              [
                "commandsWithContextGlobal",
                Decco.arrayToJson((function (param) {
                        return t_encode(t_encode$1, param);
                      }), v.commandsWithContextGlobal)
              ]
            ]);
}

function t_encode$2(v) {
  if (v.TAG === /* HasNotEvaluated */0) {
    return [
            "HasNotEvaluated",
            SwitchCommand$SmartcutsMacros.CommandValue.t_encode(t_encode$1, v._0)
          ];
  } else {
    return [
            "ResolvedToCommands",
            resolvedToCommands_encode(v._0)
          ];
  }
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "HasNotEvaluated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SwitchCommand$SmartcutsMacros.CommandValue.t_decode(t_decode$1, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* HasNotEvaluated */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ResolvedToCommands" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = resolvedToCommands_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ResolvedToCommands */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$2(switchCommand) {
  if (switchCommand.TAG === /* HasNotEvaluated */0) {
    var func = SwitchCommand$SmartcutsMacros.CommandValue.stringify;
    return "HasNotEvaluated(" + (Curry._2(func, stringify$1, switchCommand._0) + ")");
  }
  var match = switchCommand._0;
  var caseThatEvaluatedToTrue = match.caseThatEvaluatedToTrue;
  var arg = stringify$1;
  return "ResolvedToCommands({ caseThatEvaluatedToTrue: " + ((
            caseThatEvaluatedToTrue ? "Predicate(" + (Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.stringify, caseThatEvaluatedToTrue._0) + ")") : "Default"
          ) + (", commands: [" + (Belt_Array.map(match.commandsWithContextGlobal, (function (param) {
                        return stringify(param, arg);
                      })).join(", ") + "] })")));
}

function stringifyCaseThatEvaluatedToTrue(caseThatEvaluatedToTrue) {
  if (caseThatEvaluatedToTrue) {
    return "Predicate(" + (Curry._1(SwitchCommand$SmartcutsMacros.CommandValue.Predicate.stringify, caseThatEvaluatedToTrue._0) + ")");
  } else {
    return "Default";
  }
}

function stringifyResolvedToCommands(param) {
  return "{ caseThatEvaluatedToTrue: " + (stringifyCaseThatEvaluatedToTrue(param.caseThatEvaluatedToTrue) + ("commandsWithContextGlobal: [n=" + (String(param.commandsWithContextGlobal.length) + "] }")));
}

var SwitchCommandPlaybackRuntime = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  resolvedToCommands_encode: resolvedToCommands_encode,
  resolvedToCommands_decode: resolvedToCommands_decode,
  caseThatEvaluatedToTrue_encode: caseThatEvaluatedToTrue_encode,
  caseThatEvaluatedToTrue_decode: caseThatEvaluatedToTrue_decode,
  stringify: stringify$2,
  stringifyCaseThatEvaluatedToTrue: stringifyCaseThatEvaluatedToTrue,
  stringifyResolvedToCommands: stringifyResolvedToCommands
};

function currentlyIteratingThroughDomElements_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var commandValue = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandValue"), null));
  if (commandValue.TAG === /* Ok */0) {
    var queuedDataRecords = Decco.arrayFromJson((function (param) {
            return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "queuedDataRecords"), null));
    if (queuedDataRecords.TAG === /* Ok */0) {
      var completedDataRecords = Decco.arrayFromJson((function (param) {
              return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "completedDataRecords"), null));
      if (completedDataRecords.TAG === /* Ok */0) {
        var finalEffects = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalEffects"), null));
        if (finalEffects.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    commandValue: commandValue._0,
                    queuedDataRecords: queuedDataRecords._0,
                    completedDataRecords: completedDataRecords._0,
                    finalEffects: finalEffects._0
                  }
                };
        }
        var e = finalEffects._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".finalEffects" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = completedDataRecords._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".completedDataRecords" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = queuedDataRecords._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".queuedDataRecords" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = commandValue._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".commandValue" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function currentlyIteratingThroughDomElements_encode(v) {
  return Js_dict.fromArray([
              [
                "commandValue",
                Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v.commandValue)
              ],
              [
                "queuedDataRecords",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
                      }), v.queuedDataRecords)
              ],
              [
                "completedDataRecords",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
                      }), v.completedDataRecords)
              ],
              [
                "finalEffects",
                Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v.finalEffects)
              ]
            ]);
}

function t_encode$3(v) {
  if (typeof v === "number") {
    return ["DoneIteratingThroughDomElements"];
  } else if (v.TAG === /* HasNotCollectedElementsFromPageYet */0) {
    return [
            "HasNotCollectedElementsFromPageYet",
            Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v._0)
          ];
  } else {
    return [
            "CurrentlyIteratingThroughDomElements",
            currentlyIteratingThroughDomElements_encode(v._0)
          ];
  }
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CurrentlyIteratingThroughDomElements" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = currentlyIteratingThroughDomElements_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CurrentlyIteratingThroughDomElements */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DoneIteratingThroughDomElements" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DoneIteratingThroughDomElements */0
                  };
          }
      case "HasNotCollectedElementsFromPageYet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* HasNotCollectedElementsFromPageYet */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$3(playbackRuntimeCmdVal) {
  if (typeof playbackRuntimeCmdVal === "number") {
    return "DoneIteratingThroughDomElements";
  }
  if (playbackRuntimeCmdVal.TAG === /* HasNotCollectedElementsFromPageYet */0) {
    return "HasNotCollectedElementsFromPageYet(" + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, playbackRuntimeCmdVal._0) + ")");
  }
  var match = playbackRuntimeCmdVal._0;
  return "CurrentlyIteratingThroughDomElements({ commandValue: " + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, match.commandValue) + (", queuedDataRecords: [n=" + (String(match.queuedDataRecords.length) + ("], completedDataRecords: [n=" + (String(match.completedDataRecords.length) + ("], finalEffects: [" + (Belt_Array.map(match.finalEffects, WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.stringify).join(", ") + "] })")))))));
}

var WithElementGroupsCommandPlaybackRuntime = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  currentlyIteratingThroughDomElements_encode: currentlyIteratingThroughDomElements_encode,
  currentlyIteratingThroughDomElements_decode: currentlyIteratingThroughDomElements_decode,
  stringify: stringify$3
};

function tabDidEvaluateSwitchCommand_encode(v) {
  if (typeof v === "number") {
    return ["FailWithNoPredicateSatisfied"];
  } else if (v.TAG === /* ResolvedToCommands */0) {
    return [
            "ResolvedToCommands",
            Curry._1(resolvedToCommands_encode, v._0)
          ];
  } else {
    return [
            "ResolvedToDoNothing",
            Curry._1(caseThatEvaluatedToTrue_encode, v._0)
          ];
  }
}

function tabDidEvaluateSwitchCommand_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FailWithNoPredicateSatisfied" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithNoPredicateSatisfied */0
                  };
          }
      case "ResolvedToCommands" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(resolvedToCommands_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ResolvedToCommands */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ResolvedToDoNothing" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(caseThatEvaluatedToTrue_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ResolvedToDoNothing */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapSwitchCommand(cmdVal, mapNestedCommand) {
  if (cmdVal.TAG === /* HasNotEvaluated */0) {
    var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
    return {
            TAG: /* HasNotEvaluated */0,
            _0: Curry._2(func, mapNestedCommand, cmdVal._0)
          };
  }
  var resolvedToCommands = cmdVal._0;
  return {
          TAG: /* ResolvedToCommands */1,
          _0: {
            caseThatEvaluatedToTrue: resolvedToCommands.caseThatEvaluatedToTrue,
            commandsWithContextGlobal: Belt_Array.map(resolvedToCommands.commandsWithContextGlobal, mapNestedCommand)
          }
        };
}

function maybeFromPlaybackRuntimeCommand(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  if (playbackRuntimeCommand.TAG !== /* SwitchCommand */36) {
    return ;
  }
  var cmdVal = playbackRuntimeCommand._0;
  if (cmdVal.TAG === /* HasNotEvaluated */0) {
    return /* SwitchCommand */{
            _0: /* HasNotEvaluated */{
              _0: cmdVal._0
            }
          };
  }
  
}

function maybeFromPlaybackRuntimeCommandWithContextGlobal(param) {
  var contextGlobal = param.contextGlobal;
  var id = param.id;
  return Belt_Option.map(maybeFromPlaybackRuntimeCommand(param.command), (function (command) {
                return {
                        id: id,
                        command: command,
                        contextGlobal: contextGlobal
                      };
              }));
}

var WithContextGlobal = {
  maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal
};

var CommandThatCanPushFrame = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand,
  WithContextGlobal: WithContextGlobal
};

function maybeFromPlaybackRuntimeCommandWithContextGlobal$1(playbackTabId, url, param) {
  var contextGlobal = param.contextGlobal;
  var command = param.command;
  return Belt_Option.flatMap(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(contextGlobal.tabRef), (function (playbackTabIdFromContextGlobal) {
                if (typeof command === "number") {
                  switch (command) {
                    case /* ReloadCommand */0 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return /* ReloadCommand */0;
                        } else {
                          return ;
                        }
                    case /* ForwardCommand */1 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return /* ForwardCommand */1;
                        } else {
                          return ;
                        }
                    case /* BackCommand */2 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return /* BackCommand */2;
                        } else {
                          return ;
                        }
                    
                  }
                } else {
                  switch (command.TAG | 0) {
                    case /* NewWindowWithUrlCommand */1 :
                        var cmdVal = command._0;
                        if (cmdVal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* NewWindowWithUrlCommand */0,
                                  _0: cmdVal
                                };
                        } else {
                          return ;
                        }
                    case /* NewTabWithUrlCommand */3 :
                        var cmdVal$1 = command._0;
                        if (cmdVal$1.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* NewTabWithUrlCommand */1,
                                  _0: cmdVal$1
                                };
                        } else {
                          return ;
                        }
                    case /* URLCommand */6 :
                        var cmdVal$2 = command._0;
                        if (cmdVal$2.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* URLCommand */2,
                                  _0: cmdVal$2
                                };
                        } else {
                          return ;
                        }
                    case /* OpenedLinkCommand */7 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* OpenedLinkCommand */4,
                                  _0: command._0
                                };
                        } else {
                          return ;
                        }
                    case /* SubmitFormCommand */8 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* SubmitFormCommand */5,
                                  _0: command._0
                                };
                        } else {
                          return ;
                        }
                    case /* SubmitFormRedirectCommand */9 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* SubmitFormRedirectCommand */6,
                                  _0: command._0
                                };
                        } else {
                          return ;
                        }
                    case /* ClientRedirectCommand */10 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* ClientRedirectCommand */7,
                                  _0: command._0
                                };
                        } else {
                          return ;
                        }
                    case /* ServerRedirectCommand */11 :
                        if (contextGlobal.url === url && Caml_obj.caml_equal(playbackTabIdFromContextGlobal, playbackTabId)) {
                          return {
                                  TAG: /* ServerRedirectCommand */8,
                                  _0: command._0
                                };
                        } else {
                          return ;
                        }
                    case /* DownloadCommand */32 :
                        var cmdVal$3 = command._0;
                        var tabOrigin = cmdVal$3.tabOrigin;
                        var playbackTabIdFromCommandValue;
                        playbackTabIdFromCommandValue = tabOrigin.TAG === /* DownloadInNewTab */0 ? tabOrigin._0.newTab.playbackId : tabOrigin._0.playbackId;
                        if (Caml_obj.caml_equal(playbackTabIdFromCommandValue, Caml_option.some(playbackTabId))) {
                          return {
                                  TAG: /* DownloadCommand */3,
                                  _0: cmdVal$3
                                };
                        } else {
                          return ;
                        }
                    default:
                      return ;
                  }
                }
              }));
}

function isCausedByLastClickCommand(commandThatSignifyPageLoad) {
  if (typeof commandThatSignifyPageLoad === "number") {
    return false;
  }
  switch (commandThatSignifyPageLoad.TAG | 0) {
    case /* OpenedLinkCommand */4 :
        if (commandThatSignifyPageLoad._0.viaHistoryApi) {
          return false;
        } else {
          return true;
        }
    case /* DownloadCommand */3 :
    case /* SubmitFormCommand */5 :
    case /* SubmitFormRedirectCommand */6 :
    case /* ClientRedirectCommand */7 :
    case /* ServerRedirectCommand */8 :
        return true;
    default:
      return false;
  }
}

function maybeFromPlaybackRuntimeCommandWithContextGlobal$2(commandWithContextGlobal, playbackTabId, url) {
  var contextGlobal = commandWithContextGlobal.contextGlobal;
  var id = commandWithContextGlobal.id;
  var func = function (param, param$1) {
    return maybeFromPlaybackRuntimeCommandWithContextGlobal$1(playbackTabId, param, param$1);
  };
  return Belt_Option.map(Curry._2(func, url, commandWithContextGlobal), (function (command) {
                return {
                        id: id,
                        command: command,
                        contextGlobal: contextGlobal
                      };
              }));
}

var WithContextGlobal$1 = {
  maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal$2
};

var CommandThatSignifyPageLoad = {
  maybeFromPlaybackRuntimeCommandWithContextGlobal: maybeFromPlaybackRuntimeCommandWithContextGlobal$1,
  isCausedByLastClickCommand: isCausedByLastClickCommand,
  WithContextGlobal: WithContextGlobal$1
};

function maybeFromPlaybackRuntimeCommand$1(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  switch (playbackRuntimeCommand.TAG | 0) {
    case /* NewTabCommand */2 :
        return {
                TAG: /* NewTabCommand */0,
                _0: playbackRuntimeCommand._0
              };
    case /* NewTabWithUrlCommand */3 :
        return {
                TAG: /* NewTabWithUrlCommand */1,
                _0: playbackRuntimeCommand._0
              };
    case /* CloseTabCommand */4 :
        return {
                TAG: /* CloseTabCommand */2,
                _0: playbackRuntimeCommand._0
              };
    case /* FocusTabCommand */5 :
        return {
                TAG: /* FocusTabCommand */3,
                _0: playbackRuntimeCommand._0
              };
    case /* URLCommand */6 :
        return {
                TAG: /* URLCommand */4,
                _0: playbackRuntimeCommand._0
              };
    case /* OpenedLinkCommand */7 :
        return {
                TAG: /* OpenedLinkCommand */5,
                _0: playbackRuntimeCommand._0
              };
    case /* DownloadCommand */32 :
        return {
                TAG: /* DownloadCommand */6,
                _0: playbackRuntimeCommand._0
              };
    case /* SwitchCommand */36 :
        return {
                TAG: /* SwitchCommand */7,
                _0: playbackRuntimeCommand._0
              };
    default:
      return ;
  }
}

function toPlaybackRuntimeCommand(commandThatContainsTabRefInCommandValue) {
  switch (commandThatContainsTabRefInCommandValue.TAG | 0) {
    case /* NewTabCommand */0 :
        return {
                TAG: /* NewTabCommand */2,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* NewTabWithUrlCommand */1 :
        return {
                TAG: /* NewTabWithUrlCommand */3,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* CloseTabCommand */2 :
        return {
                TAG: /* CloseTabCommand */4,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* FocusTabCommand */3 :
        return {
                TAG: /* FocusTabCommand */5,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* URLCommand */4 :
        return {
                TAG: /* URLCommand */6,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* OpenedLinkCommand */5 :
        return {
                TAG: /* OpenedLinkCommand */7,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* DownloadCommand */6 :
        return {
                TAG: /* DownloadCommand */32,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    case /* SwitchCommand */7 :
        return {
                TAG: /* SwitchCommand */36,
                _0: commandThatContainsTabRefInCommandValue._0
              };
    
  }
}

function maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue, recordingTabId, playbackTabId, substitutePlaybackTabIdInContextGlobal) {
  switch (commandThatContainsTabRefInCommandValue.TAG | 0) {
    case /* NewTabCommand */0 :
        var match = commandThatContainsTabRefInCommandValue._0;
        var tabRef = match.tabRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef)) {
          return {
                  TAG: /* NewTabCommand */0,
                  _0: {
                    tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef),
                    windowRef: match.windowRef,
                    focusStatus: match.focusStatus
                  }
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* NewTabWithUrlCommand */1 :
        var match$1 = commandThatContainsTabRefInCommandValue._0;
        var tabRef$1 = match$1.tabRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$1)) {
          return {
                  TAG: /* NewTabWithUrlCommand */1,
                  _0: {
                    url: match$1.url,
                    title: match$1.title,
                    tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$1),
                    windowRef: match$1.windowRef,
                    focusStatus: match$1.focusStatus
                  }
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* CloseTabCommand */2 :
        var tabRef$2 = commandThatContainsTabRefInCommandValue._0;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$2)) {
          return {
                  TAG: /* CloseTabCommand */2,
                  _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$2)
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* FocusTabCommand */3 :
        var commandValue = commandThatContainsTabRefInCommandValue._0;
        var tabRef$3 = commandValue.tabRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$3)) {
          return {
                  TAG: /* FocusTabCommand */3,
                  _0: {
                    tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$3),
                    url: commandValue.url,
                    title: commandValue.title
                  }
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* URLCommand */4 :
        var match$2 = commandThatContainsTabRefInCommandValue._0;
        var tabRef$4 = match$2.tabRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$4)) {
          return {
                  TAG: /* URLCommand */4,
                  _0: {
                    url: match$2.url,
                    title: match$2.title,
                    tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$4)
                  }
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* OpenedLinkCommand */5 :
        var cmdVal = commandThatContainsTabRefInCommandValue._0;
        var openerTabRef = cmdVal.maybeOpenerTab;
        var tabRef$5 = cmdVal.tabRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, tabRef$5)) {
          return {
                  TAG: /* OpenedLinkCommand */5,
                  _0: {
                    tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, tabRef$5),
                    windowRef: cmdVal.windowRef,
                    url: cmdVal.url,
                    title: cmdVal.title,
                    maybeOpenerTab: cmdVal.maybeOpenerTab,
                    viaHistoryApi: cmdVal.viaHistoryApi
                  }
                };
        } else if (openerTabRef !== undefined && InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(recordingTabId, openerTabRef)) {
          return {
                  TAG: /* OpenedLinkCommand */5,
                  _0: {
                    tabRef: cmdVal.tabRef,
                    windowRef: cmdVal.windowRef,
                    url: cmdVal.url,
                    title: cmdVal.title,
                    maybeOpenerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(playbackTabId, openerTabRef),
                    viaHistoryApi: cmdVal.viaHistoryApi
                  }
                };
        } else {
          return commandThatContainsTabRefInCommandValue;
        }
    case /* DownloadCommand */6 :
        return {
                TAG: /* DownloadCommand */6,
                _0: Curry._3(DownloadCommand$SmartcutsMacros.CommandValue.Playback.maybeAssignPlaybackTabId, recordingTabId, playbackTabId, commandThatContainsTabRefInCommandValue._0)
              };
    case /* SwitchCommand */7 :
        return {
                TAG: /* SwitchCommand */7,
                _0: mapSwitchCommand(commandThatContainsTabRefInCommandValue._0, (function (commandWithContextGlobal) {
                        var command = commandWithContextGlobal.command;
                        var arg = Belt_Option.map(maybeFromPlaybackRuntimeCommand$1(command), (function (commandThatContainsTabRefInCommandValue) {
                                return toPlaybackRuntimeCommand(maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue, recordingTabId, playbackTabId, substitutePlaybackTabIdInContextGlobal));
                              }));
                        return {
                                id: commandWithContextGlobal.id,
                                command: (function (param) {
                                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                    })(command),
                                contextGlobal: Curry._3(substitutePlaybackTabIdInContextGlobal, commandWithContextGlobal.contextGlobal, recordingTabId, playbackTabId)
                              };
                      }))
              };
    
  }
}

var CommandThatContainsTabRefInCommandValue = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$1,
  toPlaybackRuntimeCommand: toPlaybackRuntimeCommand,
  maybeSubstitudePlaybackTabId: maybeSubstitudePlaybackTabId
};

function maybeFromPlaybackRuntimeCommand$2(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  switch (playbackRuntimeCommand.TAG | 0) {
    case /* NewWindowCommand */0 :
        return {
                TAG: /* NewWindowCommand */0,
                _0: playbackRuntimeCommand._0
              };
    case /* NewWindowWithUrlCommand */1 :
        return {
                TAG: /* NewWindowWithUrlCommand */1,
                _0: playbackRuntimeCommand._0
              };
    case /* NewTabCommand */2 :
        return {
                TAG: /* NewTabCommand */2,
                _0: playbackRuntimeCommand._0
              };
    case /* NewTabWithUrlCommand */3 :
        return {
                TAG: /* NewTabWithUrlCommand */3,
                _0: playbackRuntimeCommand._0
              };
    case /* SwitchCommand */36 :
        return {
                TAG: /* SwitchCommand */4,
                _0: playbackRuntimeCommand._0
              };
    default:
      return ;
  }
}

function toPlaybackRuntimeCommand$1(commandThatContainsWindowRefInCommandValue) {
  switch (commandThatContainsWindowRefInCommandValue.TAG | 0) {
    case /* NewWindowCommand */0 :
        return {
                TAG: /* NewWindowCommand */0,
                _0: commandThatContainsWindowRefInCommandValue._0
              };
    case /* NewWindowWithUrlCommand */1 :
        return {
                TAG: /* NewWindowWithUrlCommand */1,
                _0: commandThatContainsWindowRefInCommandValue._0
              };
    case /* NewTabCommand */2 :
        return {
                TAG: /* NewTabCommand */2,
                _0: commandThatContainsWindowRefInCommandValue._0
              };
    case /* NewTabWithUrlCommand */3 :
        return {
                TAG: /* NewTabWithUrlCommand */3,
                _0: commandThatContainsWindowRefInCommandValue._0
              };
    case /* SwitchCommand */4 :
        return {
                TAG: /* SwitchCommand */36,
                _0: commandThatContainsWindowRefInCommandValue._0
              };
    
  }
}

function maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue, recordingWindowId, playbackWindowId, substitutePlaybackWindowIdInContextGlobal) {
  switch (commandThatContainsWindowRefInCommandValue.TAG | 0) {
    case /* NewWindowCommand */0 :
        var match = commandThatContainsWindowRefInCommandValue._0;
        var windowRef = match.windowRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef)) {
          return {
                  TAG: /* NewWindowCommand */0,
                  _0: {
                    windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef),
                    focusStatus: match.focusStatus
                  }
                };
        } else {
          return commandThatContainsWindowRefInCommandValue;
        }
    case /* NewWindowWithUrlCommand */1 :
        return commandThatContainsWindowRefInCommandValue;
    case /* NewTabCommand */2 :
        var match$1 = commandThatContainsWindowRefInCommandValue._0;
        var windowRef$1 = match$1.windowRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef$1)) {
          return {
                  TAG: /* NewTabCommand */2,
                  _0: {
                    tabRef: match$1.tabRef,
                    windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef$1),
                    focusStatus: match$1.focusStatus
                  }
                };
        } else {
          return commandThatContainsWindowRefInCommandValue;
        }
    case /* NewTabWithUrlCommand */3 :
        var match$2 = commandThatContainsWindowRefInCommandValue._0;
        var windowRef$2 = match$2.windowRef;
        if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(recordingWindowId, windowRef$2)) {
          return {
                  TAG: /* NewTabWithUrlCommand */3,
                  _0: {
                    url: match$2.url,
                    title: match$2.title,
                    tabRef: match$2.tabRef,
                    windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(playbackWindowId, windowRef$2),
                    focusStatus: match$2.focusStatus
                  }
                };
        } else {
          return commandThatContainsWindowRefInCommandValue;
        }
    case /* SwitchCommand */4 :
        return {
                TAG: /* SwitchCommand */4,
                _0: mapSwitchCommand(commandThatContainsWindowRefInCommandValue._0, (function (commandWithContextGlobal) {
                        var command = commandWithContextGlobal.command;
                        var arg = Belt_Option.map(maybeFromPlaybackRuntimeCommand$2(command), (function (commandThatContainsWindowRefInCommandValue) {
                                return toPlaybackRuntimeCommand$1(maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue, recordingWindowId, playbackWindowId, substitutePlaybackWindowIdInContextGlobal));
                              }));
                        return {
                                id: commandWithContextGlobal.id,
                                command: (function (param) {
                                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                    })(command),
                                contextGlobal: Curry._3(substitutePlaybackWindowIdInContextGlobal, commandWithContextGlobal.contextGlobal, recordingWindowId, playbackWindowId)
                              };
                      }))
              };
    
  }
}

var CommandThatContainsWindowRefInCommandValue = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$2,
  toPlaybackRuntimeCommand: toPlaybackRuntimeCommand$1,
  maybeSubstitudePlaybackWindowId: maybeSubstitudePlaybackWindowId
};

function maybeFromPlaybackRuntimeCommand$3(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  switch (playbackRuntimeCommand.TAG | 0) {
    case /* NewWindowWithUrlCommand */1 :
        return {
                TAG: /* NewWindowWithUrlCommand */0,
                _0: playbackRuntimeCommand._0
              };
    case /* NewTabWithUrlCommand */3 :
        return {
                TAG: /* NewTabWithUrlCommand */1,
                _0: playbackRuntimeCommand._0
              };
    case /* URLCommand */6 :
        return {
                TAG: /* URLCommand */2,
                _0: playbackRuntimeCommand._0
              };
    case /* OpenedLinkCommand */7 :
        return {
                TAG: /* OpenedLinkCommand */3,
                _0: playbackRuntimeCommand._0
              };
    default:
      return ;
  }
}

var CommandThatCanUpdateUrl = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$3
};

function t_encode$4(v) {
  return t_encode(t_encode$1, v);
}

function t_decode$4(v) {
  return t_decode(t_decode$1, v);
}

var arg = stringify$1;

function stringify$4(param) {
  return stringify(param, arg);
}

function fromCommandWithContextGlobal(param) {
  var command = param.command;
  var tmp;
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
          tmp = /* ReloadCommand */0;
          break;
      case /* ForwardCommand */1 :
          tmp = /* ForwardCommand */1;
          break;
      case /* BackCommand */2 :
          tmp = /* BackCommand */2;
          break;
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowCommand */0 :
          tmp = {
            TAG: /* NewWindowCommand */0,
            _0: command._0
          };
          break;
      case /* NewWindowWithUrlCommand */1 :
          tmp = {
            TAG: /* NewWindowWithUrlCommand */1,
            _0: command._0
          };
          break;
      case /* NewTabCommand */2 :
          tmp = {
            TAG: /* NewTabCommand */2,
            _0: command._0
          };
          break;
      case /* NewTabWithUrlCommand */3 :
          tmp = {
            TAG: /* NewTabWithUrlCommand */3,
            _0: command._0
          };
          break;
      case /* CloseTabCommand */4 :
          tmp = {
            TAG: /* CloseTabCommand */4,
            _0: command._0
          };
          break;
      case /* FocusTabCommand */5 :
          tmp = {
            TAG: /* FocusTabCommand */5,
            _0: command._0
          };
          break;
      case /* URLCommand */6 :
          tmp = {
            TAG: /* URLCommand */6,
            _0: command._0
          };
          break;
      case /* OpenedLinkCommand */7 :
          tmp = {
            TAG: /* OpenedLinkCommand */7,
            _0: command._0
          };
          break;
      case /* SubmitFormCommand */8 :
          tmp = {
            TAG: /* SubmitFormCommand */8,
            _0: command._0
          };
          break;
      case /* SubmitFormRedirectCommand */9 :
          tmp = {
            TAG: /* SubmitFormRedirectCommand */9,
            _0: command._0
          };
          break;
      case /* ClientRedirectCommand */10 :
          tmp = {
            TAG: /* ClientRedirectCommand */10,
            _0: command._0
          };
          break;
      case /* ServerRedirectCommand */11 :
          tmp = {
            TAG: /* ServerRedirectCommand */11,
            _0: command._0
          };
          break;
      case /* ClickCommand */12 :
          tmp = {
            TAG: /* ClickCommand */12,
            _0: command._0
          };
          break;
      case /* ClickInputCommand */13 :
          tmp = {
            TAG: /* ClickInputCommand */13,
            _0: command._0
          };
          break;
      case /* ClickContentEditableCommand */14 :
          tmp = {
            TAG: /* ClickContentEditableCommand */14,
            _0: command._0
          };
          break;
      case /* TypeCommand */15 :
          tmp = {
            TAG: /* TypeCommand */15,
            _0: command._0
          };
          break;
      case /* CheckboxCommand */16 :
          tmp = {
            TAG: /* CheckboxCommand */16,
            _0: command._0
          };
          break;
      case /* SelectCommand */17 :
          tmp = {
            TAG: /* SelectCommand */17,
            _0: command._0
          };
          break;
      case /* RadioCommand */18 :
          tmp = {
            TAG: /* RadioCommand */18,
            _0: command._0
          };
          break;
      case /* KeyCommand */19 :
          tmp = {
            TAG: /* KeyCommand */19,
            _0: command._0
          };
          break;
      case /* KeyComboCommand */20 :
          tmp = {
            TAG: /* KeyComboCommand */20,
            _0: command._0
          };
          break;
      case /* SelectionCommand */21 :
          tmp = {
            TAG: /* SelectionCommand */21,
            _0: command._0
          };
          break;
      case /* MoveInputCursorCommand */22 :
          tmp = {
            TAG: /* MoveInputCursorCommand */22,
            _0: command._0
          };
          break;
      case /* MoveContentEditableCursorCommand */23 :
          tmp = {
            TAG: /* MoveContentEditableCursorCommand */23,
            _0: command._0
          };
          break;
      case /* CopyCommand */24 :
          tmp = {
            TAG: /* CopyCommand */24,
            _0: command._0
          };
          break;
      case /* CopyLinkAddressCommand */25 :
          tmp = {
            TAG: /* CopyLinkAddressCommand */25,
            _0: command._0
          };
          break;
      case /* CutCommand */26 :
          tmp = {
            TAG: /* CutCommand */26,
            _0: command._0
          };
          break;
      case /* PasteInInputCommand */27 :
          tmp = {
            TAG: /* PasteInInputCommand */27,
            _0: command._0
          };
          break;
      case /* PasteInContentEditableCommand */28 :
          tmp = {
            TAG: /* PasteInContentEditableCommand */28,
            _0: command._0
          };
          break;
      case /* DragCommand */29 :
          tmp = {
            TAG: /* DragCommand */29,
            _0: command._0
          };
          break;
      case /* DropCommand */30 :
          tmp = {
            TAG: /* DropCommand */30,
            _0: command._0
          };
          break;
      case /* ScrollCommand */31 :
          tmp = {
            TAG: /* ScrollCommand */31,
            _0: command._0
          };
          break;
      case /* DownloadCommand */32 :
          tmp = {
            TAG: /* DownloadCommand */32,
            _0: command._0
          };
          break;
      case /* GoogleSheetsCommand */33 :
          tmp = {
            TAG: /* GoogleSheetsCommand */33,
            _0: command._0
          };
          break;
      case /* ContextMenuCommand */34 :
          tmp = {
            TAG: /* ContextMenuCommand */34,
            _0: command._0
          };
          break;
      case /* LoopCommand */35 :
          tmp = {
            TAG: /* LoopCommand */35,
            _0: command._0
          };
          break;
      case /* SwitchCommand */36 :
          var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
          tmp = {
            TAG: /* SwitchCommand */36,
            _0: {
              TAG: /* HasNotEvaluated */0,
              _0: Curry._2(func, fromCommandWithContextGlobal, command._0)
            }
          };
          break;
      case /* ScreenshotToClipboardCommand */37 :
          tmp = {
            TAG: /* ScreenshotToClipboardCommand */37,
            _0: command._0
          };
          break;
      case /* PasteImageInContentEditableCommand */38 :
          tmp = {
            TAG: /* PasteImageInContentEditableCommand */38,
            _0: command._0
          };
          break;
      case /* PasswordCommand */39 :
          tmp = {
            TAG: /* PasswordCommand */39,
            _0: command._0
          };
          break;
      case /* ClickToOAuthCommand */40 :
          tmp = {
            TAG: /* ClickToOAuthCommand */40,
            _0: command._0
          };
          break;
      case /* UploadCommand */41 :
          tmp = {
            TAG: /* UploadCommand */41,
            _0: command._0
          };
          break;
      case /* CopyImageSrcCommand */42 :
          tmp = {
            TAG: /* CopyImageSrcCommand */42,
            _0: command._0
          };
          break;
      case /* WithElementGroupsCommand */43 :
          tmp = {
            TAG: /* WithElementGroupsCommand */43,
            _0: {
              TAG: /* HasNotCollectedElementsFromPageYet */0,
              _0: command._0
            }
          };
          break;
      
    }
  }
  return {
          id: param.id,
          command: tmp,
          contextGlobal: param.contextGlobal
        };
}

function maybeCreatedWindow(param) {
  var match = param.contextGlobal;
  var tabRef = match.tabRef;
  var windowRef = match.windowRef;
  var tmp = param.command;
  if (typeof tmp === "number") {
    return ;
  }
  switch (tmp.TAG | 0) {
    case /* NewWindowCommand */0 :
    case /* NewWindowWithUrlCommand */1 :
        return [
                windowRef,
                tabRef
              ];
    default:
      return ;
  }
}

function maybeCreatedTab(param) {
  var contextGlobal = param.contextGlobal;
  var command = param.command;
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* NewTabCommand */2 :
        return command._0.tabRef;
    case /* NewTabWithUrlCommand */3 :
        return command._0.tabRef;
    case /* OpenedLinkCommand */7 :
        var match = command._0;
        if (match.maybeOpenerTab !== undefined && !match.viaHistoryApi) {
          return match.tabRef;
        } else {
          return ;
        }
    case /* NewWindowCommand */0 :
    case /* NewWindowWithUrlCommand */1 :
    case /* ServerRedirectCommand */11 :
        return contextGlobal.tabRef;
    case /* DownloadCommand */32 :
        var match$1 = command._0.tabOrigin;
        if (match$1.TAG === /* DownloadInNewTab */0) {
          return match$1._0.newTab;
        } else {
          return ;
        }
    default:
      return ;
  }
}

function substituteTabId(recordingTabId, playbackTabId, commandWithContextGlobal) {
  var command = commandWithContextGlobal.command;
  var substitutePlaybackTabIdInContextGlobal = function (contextGlobal, recordingTabId, playbackTabId) {
    var tabRef = contextGlobal.tabRef;
    var tmp;
    var func = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId;
    if (Curry._2(func, recordingTabId, tabRef)) {
      var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId;
      tmp = Curry._2(func$1, playbackTabId, tabRef);
    } else {
      tmp = tabRef;
    }
    return {
            windowRef: contextGlobal.windowRef,
            tabRef: tmp,
            url: contextGlobal.url,
            focusStatus: contextGlobal.focusStatus,
            title: contextGlobal.title,
            frame: contextGlobal.frame,
            windowGeometry: contextGlobal.windowGeometry,
            targetBoundingRect: contextGlobal.targetBoundingRect,
            timestamp: contextGlobal.timestamp,
            htmlSnapshot: contextGlobal.htmlSnapshot,
            screenshot: contextGlobal.screenshot,
            croppedScreenshot: contextGlobal.croppedScreenshot,
            preconditions: contextGlobal.preconditions,
            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
          };
  };
  var arg = Belt_Option.map(maybeFromPlaybackRuntimeCommand$1(command), (function (commandThatContainsTabRefInCommandValue) {
          return toPlaybackRuntimeCommand(maybeSubstitudePlaybackTabId(commandThatContainsTabRefInCommandValue, recordingTabId, playbackTabId, substitutePlaybackTabIdInContextGlobal));
        }));
  return {
          id: commandWithContextGlobal.id,
          command: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(command),
          contextGlobal: substitutePlaybackTabIdInContextGlobal(commandWithContextGlobal.contextGlobal, recordingTabId, playbackTabId)
        };
}

function substituteWindowId(recordingWindowId, playbackWindowId, commandWithContextGlobal) {
  var command = commandWithContextGlobal.command;
  var substitutePlaybackWindowIdInContextGlobal = function (contextGlobal, recordingWindowId, playbackWindowId) {
    var windowRef = contextGlobal.windowRef;
    var tmp;
    var func = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId;
    if (Curry._2(func, recordingWindowId, windowRef)) {
      var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId;
      tmp = Curry._2(func$1, playbackWindowId, windowRef);
    } else {
      tmp = windowRef;
    }
    return {
            windowRef: tmp,
            tabRef: contextGlobal.tabRef,
            url: contextGlobal.url,
            focusStatus: contextGlobal.focusStatus,
            title: contextGlobal.title,
            frame: contextGlobal.frame,
            windowGeometry: contextGlobal.windowGeometry,
            targetBoundingRect: contextGlobal.targetBoundingRect,
            timestamp: contextGlobal.timestamp,
            htmlSnapshot: contextGlobal.htmlSnapshot,
            screenshot: contextGlobal.screenshot,
            croppedScreenshot: contextGlobal.croppedScreenshot,
            preconditions: contextGlobal.preconditions,
            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
          };
  };
  var arg = Belt_Option.map(maybeFromPlaybackRuntimeCommand$2(command), (function (commandThatContainsWindowRefInCommandValue) {
          return toPlaybackRuntimeCommand$1(maybeSubstitudePlaybackWindowId(commandThatContainsWindowRefInCommandValue, recordingWindowId, playbackWindowId, substitutePlaybackWindowIdInContextGlobal));
        }));
  return {
          id: commandWithContextGlobal.id,
          command: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(command),
          contextGlobal: substitutePlaybackWindowIdInContextGlobal(commandWithContextGlobal.contextGlobal, recordingWindowId, playbackWindowId)
        };
}

function tabRefThatBlocksCommand(param, playbackOptions) {
  var contextGlobal = param.contextGlobal;
  var command = param.command;
  if (typeof command === "number") {
    return contextGlobal.tabRef;
  }
  switch (command.TAG | 0) {
    case /* CloseTabCommand */4 :
        return command._0;
    case /* FocusTabCommand */5 :
        var tabRef = command._0.tabRef;
        if (tabRef.playbackId === undefined) {
          return tabRef;
        } else {
          return ;
        }
    case /* URLCommand */6 :
        return command._0.tabRef;
    case /* NewWindowCommand */0 :
    case /* NewWindowWithUrlCommand */1 :
    case /* NewTabCommand */2 :
    case /* NewTabWithUrlCommand */3 :
    case /* OpenedLinkCommand */7 :
    case /* SubmitFormCommand */8 :
    case /* SubmitFormRedirectCommand */9 :
    case /* ClientRedirectCommand */10 :
    case /* ServerRedirectCommand */11 :
        return ;
    case /* DownloadCommand */32 :
        if (command._0.tabOrigin.TAG === /* DownloadInNewTab */0) {
          return ;
        } else {
          return contextGlobal.tabRef;
        }
    case /* GoogleSheetsCommand */33 :
        if (playbackOptions.replaceUiCommandsWithApiCommands) {
          return ;
        } else {
          return contextGlobal.tabRef;
        }
    default:
      return contextGlobal.tabRef;
  }
}

function maybeSubstituteUrlFromCompletedCommandWithContextGlobal(completedCommandWithContextGlobal, commandWithContextGlobal) {
  var contextGlobal = commandWithContextGlobal.contextGlobal;
  var maybeUpdateUrl = Belt_Option.flatMap(maybeFromPlaybackRuntimeCommand$3(completedCommandWithContextGlobal.command), (function (commandThatCanUpdateUrl) {
          var match = completedCommandWithContextGlobal.contextGlobal;
          var match$1;
          switch (commandThatCanUpdateUrl.TAG | 0) {
            case /* NewWindowWithUrlCommand */0 :
            case /* NewTabWithUrlCommand */1 :
                match$1 = [
                  match.tabRef,
                  commandThatCanUpdateUrl._0.url
                ];
                break;
            case /* URLCommand */2 :
                var match$2 = commandThatCanUpdateUrl._0;
                match$1 = [
                  match$2.tabRef,
                  match$2.url
                ];
                break;
            case /* OpenedLinkCommand */3 :
                var match$3 = commandThatCanUpdateUrl._0;
                match$1 = [
                  match$3.tabRef,
                  match$3.url
                ];
                break;
            
          }
          if (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef(contextGlobal.tabRef, match$1[0])) {
            return match$1[1];
          }
          
        }));
  var arg = Belt_Option.map(maybeUpdateUrl, (function (url) {
          return {
                  id: commandWithContextGlobal.id,
                  command: commandWithContextGlobal.command,
                  contextGlobal: {
                    windowRef: contextGlobal.windowRef,
                    tabRef: contextGlobal.tabRef,
                    url: url,
                    focusStatus: contextGlobal.focusStatus,
                    title: contextGlobal.title,
                    frame: contextGlobal.frame,
                    windowGeometry: contextGlobal.windowGeometry,
                    targetBoundingRect: contextGlobal.targetBoundingRect,
                    timestamp: contextGlobal.timestamp,
                    htmlSnapshot: contextGlobal.htmlSnapshot,
                    screenshot: contextGlobal.screenshot,
                    croppedScreenshot: contextGlobal.croppedScreenshot,
                    preconditions: contextGlobal.preconditions,
                    maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                  }
                };
        }));
  return OptionUtils$SmartcutsMacros.withDefault(commandWithContextGlobal, arg);
}

var WithContextGlobal$2 = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$4,
  fromCommandWithContextGlobal: fromCommandWithContextGlobal,
  maybeCreatedWindow: maybeCreatedWindow,
  maybeCreatedTab: maybeCreatedTab,
  substituteTabId: substituteTabId,
  substituteWindowId: substituteWindowId,
  tabRefThatBlocksCommand: tabRefThatBlocksCommand,
  maybeSubstituteUrlFromCompletedCommandWithContextGlobal: maybeSubstituteUrlFromCompletedCommandWithContextGlobal
};

function maybeFromPlaybackRuntimeCommand$4(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  if (playbackRuntimeCommand.TAG !== /* WithElementGroupsCommand */43) {
    return ;
  }
  var cmdVal = playbackRuntimeCommand._0;
  if (typeof cmdVal === "number") {
    return ;
  } else if (cmdVal.TAG === /* HasNotCollectedElementsFromPageYet */0) {
    return /* WithElementGroupsCommand */{
            _0: {
              TAG: /* HasNotCollectedElementsFromPageYet */0,
              _0: cmdVal._0
            }
          };
  } else {
    return /* WithElementGroupsCommand */{
            _0: {
              TAG: /* CurrentlyIteratingThroughDomElements */1,
              _0: cmdVal._0
            }
          };
  }
}

function event_encode(v) {
  return [
          "DidCollectDataRecords",
          Decco.arrayToJson((function (param) {
                  return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
                }), v._0)
        ];
}

function event_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidCollectDataRecords") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.arrayFromJson((function (param) {
            return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
          }), Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DidCollectDataRecords */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyEvent($$event) {
  return "DidCollectDataRecords([n=" + (String($$event._0.length) + "])");
}

function sideEffect_encode(v) {
  if (v) {
    return [
            "ExecuteFinalEffectsAndDispatchCompletedCommand",
            Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v._0)
          ];
  } else {
    return ["DispatchIterateThroughDataRecords"];
  }
}

function sideEffect_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DispatchIterateThroughDataRecords" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DispatchIterateThroughDataRecords */0
                  };
          }
      case "ExecuteFinalEffectsAndDispatchCompletedCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExecuteFinalEffectsAndDispatchCompletedCommand */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function handleEvent($$event, command) {
  var dataRecords = $$event._0;
  var maybeClipDataRecordsToRemainingLoadItems = function (loadItems, nCompletedItems, dataRecords) {
    if (typeof loadItems === "number") {
      return dataRecords;
    }
    var nRemaining = loadItems._0 - nCompletedItems | 0;
    if (nRemaining < dataRecords.length) {
      return Belt_Array.slice(dataRecords, 0, nRemaining);
    } else {
      return dataRecords;
    }
  };
  var commandValue = command._0;
  if (commandValue.TAG === /* HasNotCollectedElementsFromPageYet */0) {
    var commandValue$1 = commandValue._0;
    var loadItems = commandValue$1.paginateOptions.loadItems;
    var func = function (param, param$1) {
      return maybeClipDataRecordsToRemainingLoadItems(loadItems, param, param$1);
    };
    return [
            {
              TAG: /* WithElementGroupsCommand */43,
              _0: {
                TAG: /* CurrentlyIteratingThroughDomElements */1,
                _0: {
                  commandValue: commandValue$1,
                  queuedDataRecords: Curry._2(func, 0, dataRecords),
                  completedDataRecords: [],
                  finalEffects: []
                }
              }
            },
            [/* DispatchIterateThroughDataRecords */0]
          ];
  }
  var currentlyIteratingThroughDomElements = commandValue._0;
  var loadItems$1 = currentlyIteratingThroughDomElements.commandValue.paginateOptions.loadItems;
  if (dataRecords.length === 0) {
    return [
            {
              TAG: /* WithElementGroupsCommand */43,
              _0: {
                TAG: /* CurrentlyIteratingThroughDomElements */1,
                _0: currentlyIteratingThroughDomElements
              }
            },
            [/* ExecuteFinalEffectsAndDispatchCompletedCommand */{
                _0: currentlyIteratingThroughDomElements.finalEffects
              }]
          ];
  }
  var func$1 = function (param, param$1) {
    return maybeClipDataRecordsToRemainingLoadItems(loadItems$1, param, param$1);
  };
  return [
          {
            TAG: /* WithElementGroupsCommand */43,
            _0: {
              TAG: /* CurrentlyIteratingThroughDomElements */1,
              _0: {
                commandValue: currentlyIteratingThroughDomElements.commandValue,
                queuedDataRecords: Curry._2(func$1, currentlyIteratingThroughDomElements.completedDataRecords.length, dataRecords),
                completedDataRecords: currentlyIteratingThroughDomElements.completedDataRecords,
                finalEffects: currentlyIteratingThroughDomElements.finalEffects
              }
            }
          },
          [/* DispatchIterateThroughDataRecords */0]
        ];
}

var CommandThatCollectsDataRecords = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$4,
  event_encode: event_encode,
  event_decode: event_decode,
  stringifyEvent: stringifyEvent,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  handleEvent: handleEvent
};

function maybeFromPlaybackRuntimeCommand$5(playbackRuntimeCommand) {
  if (typeof playbackRuntimeCommand === "number") {
    return ;
  }
  if (playbackRuntimeCommand.TAG !== /* WithElementGroupsCommand */43) {
    return ;
  }
  var currentlyIteratingThroughDomElements = playbackRuntimeCommand._0;
  if (typeof currentlyIteratingThroughDomElements === "number" || currentlyIteratingThroughDomElements.TAG === /* HasNotCollectedElementsFromPageYet */0) {
    return ;
  } else {
    return /* WithElementGroupsCommand */{
            _0: /* CurrentlyIteratingThroughDomElements */{
              _0: currentlyIteratingThroughDomElements._0
            }
          };
  }
}

function saveRowToDestination_encode(v) {
  return Js_dict.fromArray([
              [
                "destination",
                Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_encode, v.destination)
              ],
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
                      }), v.columns)
              ],
              [
                "maybeExtraColumns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
                      }), v.maybeExtraColumns)
              ],
              [
                "row",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                      }), v.row)
              ]
            ]);
}

function saveRowToDestination_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var destination = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
  if (destination.TAG === /* Ok */0) {
    var columns = Decco.arrayFromJson((function (param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */0) {
      var maybeExtraColumns = Decco.optionFromJson((function (param) {
              return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
      if (maybeExtraColumns.TAG === /* Ok */0) {
        var row = Decco.arrayFromJson((function (param) {
                return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "row"), null));
        if (row.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    destination: destination._0,
                    columns: columns._0,
                    maybeExtraColumns: maybeExtraColumns._0,
                    row: row._0
                  }
                };
        }
        var e = row._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".row" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = maybeExtraColumns._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeExtraColumns" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = columns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".columns" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = destination._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".destination" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function newFinalEffect_encode(v) {
  return [
          "SaveRowToDestination",
          saveRowToDestination_encode(v._0)
        ];
}

function newFinalEffect_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SaveRowToDestination") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = saveRowToDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SaveRowToDestination */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function event_encode$1(v) {
  if (typeof v === "number") {
    if (v === /* IterateThroughDataRecords */0) {
      return ["IterateThroughDataRecords"];
    } else {
      return ["DidCompleteCurrentIteration"];
    }
  } else if (v.TAG === /* NewFinalEffect */0) {
    return [
            "NewFinalEffect",
            newFinalEffect_encode(v._0)
          ];
  } else {
    return [
            "DidCompleteActionsOnDataRecord",
            DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, v._0)
          ];
  }
}

function event_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidCompleteActionsOnDataRecord" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidCompleteActionsOnDataRecord */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidCompleteCurrentIteration" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidCompleteCurrentIteration */1
                  };
          }
      case "IterateThroughDataRecords" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* IterateThroughDataRecords */0
                  };
          }
      case "NewFinalEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = newFinalEffect_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewFinalEffect */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sideEffect_encode$1(v) {
  if (typeof v === "number") {
    return ["DispatchDidCompleteCurrentIteration"];
  } else if (v.TAG === /* ExecuteActionsWithDataRecord */0) {
    return [
            "ExecuteActionsWithDataRecord",
            Decco.arrayToJson(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.action_encode, v._0),
            DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, v._1)
          ];
  } else {
    return [
            "ExecuteFinalEffectsAndDispatchCompletedCommand",
            Decco.arrayToJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_encode, v._0)
          ];
  }
}

function sideEffect_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DispatchDidCompleteCurrentIteration" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DispatchDidCompleteCurrentIteration */0
                  };
          }
      case "ExecuteActionsWithDataRecord" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.arrayFromJson(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.action_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ExecuteActionsWithDataRecord */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ExecuteFinalEffectsAndDispatchCompletedCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */1,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyEvent$1($$event) {
  if (typeof $$event === "number") {
    if ($$event === /* IterateThroughDataRecords */0) {
      return "IterateThroughDataRecords";
    } else {
      return "DidCompleteCurrentIteration";
    }
  } else if ($$event.TAG === /* NewFinalEffect */0) {
    return "NewFinalEffect(SaveRowToDestination({destination: " + (Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringifyDestination, $$event._0._0.destination) + ", columns, row}))");
  } else {
    return "DidCompleteActionsOnDataRecord(dataRecord)";
  }
}

function stringifySideEffect(sideEffect) {
  if (typeof sideEffect === "number") {
    return "DispatchDidCompleteCurrentIteration";
  } else if (sideEffect.TAG === /* ExecuteActionsWithDataRecord */0) {
    return "ExecuteActionsWithDataRecord(actions=[" + (Belt_Array.map(sideEffect._0, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringifyAction).join(",") + "], dataRecord)");
  } else {
    return "ExecuteFinalEffectsAndDispatchCompletedCommand([" + (Belt_Array.map(sideEffect._0, WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.stringify).join(",") + "])");
  }
}

function executeSideEffect(sideEffect, dispatchEvent, onCompletedFinalEffects, currentUrl) {
  if (typeof sideEffect === "number") {
    return Curry._1(dispatchEvent, /* DidCompleteCurrentIteration */1).then(function (param) {
                return {
                        TAG: /* Ok */0,
                        _0: undefined
                      };
              });
  }
  if (sideEffect.TAG !== /* ExecuteActionsWithDataRecord */0) {
    return PromiseUtils$SmartcutsMacros.sequentiallyEvalResults((function (param) {
                    return WithElementGroupsCommand__Playback__FinalEffect$SmartcutsMacros.execute(currentUrl, param);
                  }), sideEffect._0).then(function (results) {
                if (results.TAG === /* Ok */0) {
                  return Curry._1(onCompletedFinalEffects, results._0).then(function (param) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: undefined
                                    };
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: results._0.error
                            });
                }
              });
  }
  var dataRecord = sideEffect._1;
  return PromiseUtils$SmartcutsMacros.sequentially((function (action) {
                    var match = action._0;
                    var columns = match.columns;
                    var row = DataExtraction__ExportToTable$SmartcutsMacros.rowFromDataNodeWithId(columns, dataRecord);
                    return Curry._1(dispatchEvent, {
                                TAG: /* NewFinalEffect */0,
                                _0: /* SaveRowToDestination */{
                                  _0: {
                                    destination: match.destination,
                                    columns: columns,
                                    maybeExtraColumns: match.maybeExtraColumns,
                                    row: row
                                  }
                                }
                              });
                  }), sideEffect._0).then(function (_results) {
                return Curry._1(dispatchEvent, {
                            TAG: /* DidCompleteActionsOnDataRecord */1,
                            _0: dataRecord
                          });
              }).then(function (param) {
              return Promise.resolve({
                          TAG: /* Ok */0,
                          _0: undefined
                        });
            });
}

function handleEvent$1($$event, command) {
  if (typeof $$event === "number") {
    if ($$event === /* IterateThroughDataRecords */0) {
      var currentlyIteratingThroughDomElements = command._0._0;
      var match = ArrayUtils$SmartcutsMacros.splitAtFirst(currentlyIteratingThroughDomElements.queuedDataRecords);
      var match$1 = match !== undefined ? [
          match[1],
          [{
              TAG: /* ExecuteActionsWithDataRecord */0,
              _0: currentlyIteratingThroughDomElements.commandValue.actions,
              _1: match[0]
            }]
        ] : [
          [],
          [/* DispatchDidCompleteCurrentIteration */0]
        ];
      return [
              {
                TAG: /* WithElementGroupsCommand */43,
                _0: {
                  TAG: /* CurrentlyIteratingThroughDomElements */1,
                  _0: {
                    commandValue: currentlyIteratingThroughDomElements.commandValue,
                    queuedDataRecords: match$1[0],
                    completedDataRecords: currentlyIteratingThroughDomElements.completedDataRecords,
                    finalEffects: currentlyIteratingThroughDomElements.finalEffects
                  }
                }
              },
              match$1[1]
            ];
    }
    var match$2 = command._0._0;
    var finalEffects = match$2.finalEffects;
    var loadItems = match$2.commandValue.paginateOptions.loadItems;
    if (typeof loadItems === "number") {
      if (loadItems !== 0) {
        return [
                undefined,
                [/* PaginateAndCollectDataRecords */1]
              ];
      } else {
        return [
                undefined,
                [{
                    TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */1,
                    _0: finalEffects
                  }]
              ];
      }
    }
    var nCompletedItems = match$2.completedDataRecords.length;
    if (nCompletedItems >= loadItems._0) {
      return [
              undefined,
              [{
                  TAG: /* ExecuteFinalEffectsAndDispatchCompletedCommand */1,
                  _0: finalEffects
                }]
            ];
    } else {
      return [
              undefined,
              [/* PaginateAndCollectDataRecords */1]
            ];
    }
  } else {
    if ($$event.TAG === /* NewFinalEffect */0) {
      var match$3 = $$event._0._0;
      var maybeExtraColumns = match$3.maybeExtraColumns;
      var columns = match$3.columns;
      var destination = match$3.destination;
      var newRows = [match$3.row];
      var currentlyIteratingThroughDomElements$1 = command._0._0;
      var finalEffects$1 = currentlyIteratingThroughDomElements$1.finalEffects;
      var match$4 = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (finalEffect, index) {
              var saveRowsToDestination = finalEffect._0;
              if (Caml_obj.caml_equal(saveRowsToDestination.destination, destination)) {
                return [
                        saveRowsToDestination.rows,
                        index
                      ];
              }
              
            }), finalEffects$1);
      var nextFinalEffects = match$4 !== undefined ? ArrayUtils$SmartcutsMacros.replaceAtIndex(finalEffects$1, match$4[1], /* SaveRowsToDestination */{
              _0: {
                destination: destination,
                columns: columns,
                maybeExtraColumns: maybeExtraColumns,
                rows: Belt_Array.concat(match$4[0], newRows)
              }
            }) : [/* SaveRowsToDestination */{
            _0: {
              destination: destination,
              columns: columns,
              maybeExtraColumns: maybeExtraColumns,
              rows: newRows
            }
          }];
      return [
              {
                TAG: /* WithElementGroupsCommand */43,
                _0: {
                  TAG: /* CurrentlyIteratingThroughDomElements */1,
                  _0: {
                    commandValue: currentlyIteratingThroughDomElements$1.commandValue,
                    queuedDataRecords: currentlyIteratingThroughDomElements$1.queuedDataRecords,
                    completedDataRecords: currentlyIteratingThroughDomElements$1.completedDataRecords,
                    finalEffects: nextFinalEffects
                  }
                }
              },
              []
            ];
    }
    var currentlyIteratingThroughDomElements$2 = command._0._0;
    var match$5 = ArrayUtils$SmartcutsMacros.splitAtFirst(currentlyIteratingThroughDomElements$2.queuedDataRecords);
    var match$6 = match$5 !== undefined ? [
        match$5[1],
        [{
            TAG: /* ExecuteActionsWithDataRecord */0,
            _0: currentlyIteratingThroughDomElements$2.commandValue.actions,
            _1: match$5[0]
          }]
      ] : [
        [],
        [/* DispatchDidCompleteCurrentIteration */0]
      ];
    return [
            {
              TAG: /* WithElementGroupsCommand */43,
              _0: {
                TAG: /* CurrentlyIteratingThroughDomElements */1,
                _0: {
                  commandValue: currentlyIteratingThroughDomElements$2.commandValue,
                  queuedDataRecords: match$6[0],
                  completedDataRecords: Belt_Array.concat(currentlyIteratingThroughDomElements$2.completedDataRecords, [$$event._0]),
                  finalEffects: currentlyIteratingThroughDomElements$2.finalEffects
                }
              }
            },
            match$6[1]
          ];
  }
}

var CommandThatIteratesOverDataRecords = {
  maybeFromPlaybackRuntimeCommand: maybeFromPlaybackRuntimeCommand$5,
  saveRowToDestination_encode: saveRowToDestination_encode,
  saveRowToDestination_decode: saveRowToDestination_decode,
  newFinalEffect_encode: newFinalEffect_encode,
  newFinalEffect_decode: newFinalEffect_decode,
  event_encode: event_encode$1,
  event_decode: event_decode$1,
  sideEffect_encode: sideEffect_encode$1,
  sideEffect_decode: sideEffect_decode$1,
  stringifyEvent: stringifyEvent$1,
  stringifySideEffect: stringifySideEffect,
  executeSideEffect: executeSideEffect,
  handleEvent: handleEvent$1
};

function isFollowedBySubsequentNetworkLatency(command) {
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
      case /* ForwardCommand */1 :
      case /* BackCommand */2 :
          return true;
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* ClickCommand */12 :
          var match = Selector$SmartcutsMacros.maybeGetLeafNode(command._0.selector);
          if (match === undefined) {
            return false;
          }
          var s = match.innerText;
          if (typeof s === "number") {
            return false;
          }
          if (s.TAG !== /* FullInnerText */0) {
            return false;
          }
          var match$1 = $$String.lowercase_ascii(s._0);
          switch (match$1) {
            case "confirm" :
            case "create" :
            case "save" :
                return true;
            default:
              return false;
          }
      case /* NewWindowWithUrlCommand */1 :
      case /* NewTabWithUrlCommand */3 :
      case /* URLCommand */6 :
      case /* OpenedLinkCommand */7 :
      case /* SubmitFormCommand */8 :
      case /* SubmitFormRedirectCommand */9 :
      case /* ClientRedirectCommand */10 :
      case /* ServerRedirectCommand */11 :
      case /* ClickToOAuthCommand */40 :
      case /* UploadCommand */41 :
          return true;
      default:
        return false;
    }
  }
}

function selectorGet(command) {
  if (typeof command === "number") {
    return [];
  }
  switch (command.TAG | 0) {
    case /* ClickCommand */12 :
        return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickInputCommand */13 :
        return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickContentEditableCommand */14 :
        return Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* TypeCommand */15 :
        return Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* CheckboxCommand */16 :
        return Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.CheckboxPlaybackCommandValue.selectorGet, command._0);
    case /* SelectCommand */17 :
        return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* RadioCommand */18 :
        return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* MoveInputCursorCommand */22 :
        return Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* MoveContentEditableCursorCommand */23 :
        return Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* CopyLinkAddressCommand */25 :
        return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* SelectionCommand */21 :
    case /* CopyCommand */24 :
    case /* CutCommand */26 :
        break;
    case /* PasteInInputCommand */27 :
        return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasteInContentEditableCommand */28 :
        return Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* DragCommand */29 :
    case /* DropCommand */30 :
        return [command._0];
    case /* ScrollCommand */31 :
        return ScrollCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* ContextMenuCommand */34 :
        return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* LoopCommand */35 :
        return LoopCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* SwitchCommand */36 :
        var commandValue = command._0;
        if (commandValue.TAG !== /* HasNotEvaluated */0) {
          return [];
        }
        var func = SwitchCommand$SmartcutsMacros.CommandValue.selectorGet;
        return Curry._2(func, selectorGet, commandValue._0);
    case /* ScreenshotToClipboardCommand */37 :
        return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasteImageInContentEditableCommand */38 :
        return Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasswordCommand */39 :
        return Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickToOAuthCommand */40 :
        return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* UploadCommand */41 :
        return UploadCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* CopyImageSrcCommand */42 :
        return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* WithElementGroupsCommand */43 :
        return [];
    default:
      return [];
  }
  return Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
}

function updateNextOpenedLinkCommandWithPlaybackUrl(tabId, playbackUrl, commands) {
  var match = ArrayUtils$SmartcutsMacros.firstMatchi((function (param) {
          var command = param.command;
          if (typeof command === "number") {
            return false;
          }
          if (command.TAG !== /* OpenedLinkCommand */7) {
            return false;
          }
          var playbackTabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(command._0.tabRef);
          if (playbackTabId !== undefined) {
            return Caml_obj.caml_equal(Caml_option.valFromOption(playbackTabId), tabId);
          } else {
            return false;
          }
        }), commands);
  if (match === undefined) {
    return commands;
  }
  var commandWithContextGlobal = match[0];
  var cmdVal = commandWithContextGlobal.command;
  if (typeof cmdVal === "number") {
    return commands;
  }
  if (cmdVal.TAG !== /* OpenedLinkCommand */7) {
    return commands;
  }
  var contextGlobal = commandWithContextGlobal.contextGlobal;
  var cmdVal$1 = cmdVal._0;
  return ArrayUtils$SmartcutsMacros.replaceAtIndex(commands, match[1], {
              id: commandWithContextGlobal.id,
              command: {
                TAG: /* OpenedLinkCommand */7,
                _0: {
                  tabRef: cmdVal$1.tabRef,
                  windowRef: cmdVal$1.windowRef,
                  url: playbackUrl,
                  title: cmdVal$1.title,
                  maybeOpenerTab: cmdVal$1.maybeOpenerTab,
                  viaHistoryApi: cmdVal$1.viaHistoryApi
                }
              },
              contextGlobal: {
                windowRef: contextGlobal.windowRef,
                tabRef: contextGlobal.tabRef,
                url: playbackUrl,
                focusStatus: contextGlobal.focusStatus,
                title: contextGlobal.title,
                frame: contextGlobal.frame,
                windowGeometry: contextGlobal.windowGeometry,
                targetBoundingRect: contextGlobal.targetBoundingRect,
                timestamp: contextGlobal.timestamp,
                htmlSnapshot: contextGlobal.htmlSnapshot,
                screenshot: contextGlobal.screenshot,
                croppedScreenshot: contextGlobal.croppedScreenshot,
                preconditions: contextGlobal.preconditions,
                maybeLogoutLocator: contextGlobal.maybeLogoutLocator
              }
            });
}

exports.CommandWithContextGlobal = CommandWithContextGlobal;
exports.CommandType = CommandType;
exports.SwitchCommandPlaybackRuntime = SwitchCommandPlaybackRuntime;
exports.WithElementGroupsCommandPlaybackRuntime = WithElementGroupsCommandPlaybackRuntime;
exports.tabDidEvaluateSwitchCommand_encode = tabDidEvaluateSwitchCommand_encode;
exports.tabDidEvaluateSwitchCommand_decode = tabDidEvaluateSwitchCommand_decode;
exports.mapSwitchCommand = mapSwitchCommand;
exports.CommandThatCanPushFrame = CommandThatCanPushFrame;
exports.CommandThatSignifyPageLoad = CommandThatSignifyPageLoad;
exports.CommandThatContainsTabRefInCommandValue = CommandThatContainsTabRefInCommandValue;
exports.CommandThatContainsWindowRefInCommandValue = CommandThatContainsWindowRefInCommandValue;
exports.CommandThatCanUpdateUrl = CommandThatCanUpdateUrl;
exports.WithContextGlobal = WithContextGlobal$2;
exports.CommandThatCollectsDataRecords = CommandThatCollectsDataRecords;
exports.CommandThatIteratesOverDataRecords = CommandThatIteratesOverDataRecords;
exports.isFollowedBySubsequentNetworkLatency = isFollowedBySubsequentNetworkLatency;
exports.selectorGet = selectorGet;
exports.updateNextOpenedLinkCommandWithPlaybackUrl = updateNextOpenedLinkCommandWithPlaybackUrl;
/* Selector-SmartcutsMacros Not a pure module */
